module.exports = __webpack_public_path__ + "img/79.10e7683d.jpg";